const _bookATour = "Book A Tour";
const _realtorTour = "Realtor Tour";
const _virtual = "Virtual";
const _inperson = "In Person";

$(document).ready(function () {

    $(".dropdown-with-autocomplete").select2({
        theme: "foundation"
    });

    $("#tour_schedule_inperson_tour_checkbox").on("change", function () {
        TourScheduleFormProcessSubSource();
    });

    $("#tour_schedule_virtual_tour_checkbox").on("change", function () {
        TourScheduleFormProcessSubSource();
    });

    $("#tour_schedule_homebuyer_checkbox").on("change", function () {
        TourScheduleFormProcessLeadSource();
    });

    $("#tour_schedule_agent_checkbox").on("change", function () {
        TourScheduleFormProcessLeadSource();
    });

});


$(function () {
    $('[data-open="tour-schedule-form-modal"]').on('click touchstart keypress', function () {
        if ($('#tour-schedule-metro-area-select').length) {

            var trigger = $(this);
            var id = '';
            var email = trigger.data('email');
            var metro = trigger.data('metro');
            var community = trigger.data('community');

            $("#tour_schedule_date_picker").val($(this).data("date"));

            fetchTourData();

            if (metro) {
                id = metro;
                id = '{' + id + '}';
                id = id.toString().toUpperCase();
            } else if ($('#FormModel_MetroArea').length) {
                id = $('#FormModel_MetroArea').val();
            }

            var metroselect = $('#tour-schedule-metro-area-select');
            metroselect.find('option').first().nextAll().remove();

            $.getJSON("/api/Sitecore/MetroCommunity/Metro", function (data) {
                appendInputs(data, $('#tour-schedule-metro-area-select'), id);
            });

            var communityID = '';
            if (community) {
                communityID = community;
                communityID = '{' + communityID + '}';
                communityID = communityID.toString().toUpperCase();
            } else if ($('#FormModel_Community').length) {
                communityID = $('#FormModel_Community').val();
            }


            if (communityID) {
                // add community to start
                var communitySelect = $('#tour-schedule-community-select');

                communitySelect.find("option").first().nextAll().remove();

                $.getJSON('/api/Sitecore/MetroCommunity/Community?id=' + id, function (data) {
                    appendInputs(data, communitySelect, communityID);
                }).then(function () {
                    communitySelect.prop('disabled', false);
                });

            }
        }

        var tourType = initTourType(this);
        
        switch (tourType) {
            case 'inperson':
                $('#tour_schedule_inperson_tour_checkbox').prop('checked', true);
                break;
            case 'virtual':
                $('#tour_schedule_virtual_tour_checkbox').prop('checked', true);
                break;
            default:
                $('#tour_schedule_inperson_tour_checkbox').prop('checked', true);
        }

        InitializeOldTourSchedulerForm();

    });

    function fetchTourData() {

        $('#tour_schedule_time_picker').empty();
        $('#tour_schedule_time_picker').prop('disabled', true);
        $('#submitForm').prop('disabled', true);

        var dayName = new Date($('[data-open="tour-schedule-form-modal"]').data("date")).toLocaleString('en-US', { timeZone: 'UTC', weekday: 'long' });
        var officeHrsId = "{" + $('[data-open="tour-schedule-form-modal"]').data("community") + "}";

        console.log("dayName" + dayName);
        console.log("officeHrsId" + officeHrsId);

        $.getJSON('/api/sitecore/ContactUsForm/getTourTimes?dayOfweek=' + dayName + '&officeHrsId=' + officeHrsId, function (data) {
            console.log("data" + data);

            if (data[0].value == 'Appointment-Only' || data[0].Value == "Not Open") {
                var dateControl = document.querySelector('input[type="date"]');
                dateControl.value = '';
            }

            var dateString = ($('#tour_schedule_date_picker').val() + " 00:00").replaceAll('-', '/'); //YYYY-mm-dd format is not supported on IOS devices.
            console.log("dateString" + dateString);

            var selectedDateTime = new Date(dateString);

            var today = new Date();
            today.setHours(0, 0, 0, 0);

            var currentTime = new Date();


            //Check only if date is today
            if (selectedDateTime.getFullYear() === today.getFullYear() &&
                selectedDateTime.getMonth() === today.getMonth() &&
                selectedDateTime.getDate() === today.getDate()) {

                var isDefault = true;

                var noTimeSlots = true;

                for (var i = 0; i < data.length-1; i++) {

                    //available time slots for current day
                    var tourTimeSlotString = $('#tour_schedule_date_picker').val().concat(" ", data[i].Value).replaceAll('-', '/'); //YYYY-mm-dd format is not supported on IOS devices.
                    var tourTimeSlot = new Date(tourTimeSlotString);

                    var timeDiff = ((tourTimeSlot.getHours() * 60) + tourTimeSlot.getMinutes()) - ((currentTime.getHours() * 60) + currentTime.getMinutes());

                    if (timeDiff < 120) {

                        $('#tour_schedule_time_picker').append('<option disabled value="' + data[i].Value + '">' + data[i].Value + '</option> ');

                    } else {
                        if (isDefault === true) {

                            $('#tour_schedule_time_picker').append('<option selected="selected" value="' + data[i].Value + '">' + data[i].Value + '</option>');
                            isDefault = false;

                        } else {
                            $('#tour_schedule_time_picker').append('<option value="' + data[i].Value + '">' + data[i].Value + '</option>');

                        };

                        noTimeSlots = false;
                    }
                }

                if (noTimeSlots === true) {
                    $('#noAvailableTimeSlotsMsg').css("visibility", "visible");
                   
                    $('#tour_schedule_time_picker').empty(); 
                    $('#submitForm').prop('disabled', true);

                } else {
                    $('#tour_schedule_time_picker').prop('disabled', false);
                    $('#submitForm').prop('disabled', false);
                }

            } else {
               
                $('#tour_schedule_time_picker').prop('disabled', false);
                $('#submitForm').prop('disabled', false);
                $('#noAvailableTimeSlotsMsg').css("visibility", "hidden");

                for (var i = 0; i < data.length-1; i++) {
                    $('#tour_schedule_time_picker').append('<option value="' + data[i].Value + '">' + data[i].Value + '</option>');
                }
            }
        });
    };

    $('#tour_schedule_date_picker').on('change', function () {
        fetchTourData();    
    });

    function initTourType(bookATourButton) {
        var buttonParent = $(bookATourButton).parents('.tour-scheduler');
        var tourType;
        if ($(buttonParent).find('#inperson').val() === 'selected') {
            tourType = 'inperson';
        }
        else if ($(buttonParent).find('#virtual').val() === 'selected') {
            tourType = 'virtual';
        }

        return tourType;
    }

    function virtualButtonClick() {
        $(this).addClass('tour-selected');
        $(this).siblings('#inPersonButton').removeClass('tour-selected');
        $(this).siblings('#virtual').val('selected');
        $(this).siblings('#inperson').val('');
    }

    function inPersonButtonClick() {
        $(this).addClass('tour-selected');
        $(this).siblings('#virtualButton').removeClass('tour-selected');
        $(this).siblings('#inperson').val('selected');
        $(this).siblings('#virtual').val('');
    }

    var idCount = 0;

    if ($(".tour-scheduler.generic-slider").is(":visible")) {
        $(".tour-scheduler.generic-slider").each(function () {

            var tourSchedulerID = "tour-scheduler-id-" + idCount;
            var tourSchedulerSelector = "#" + tourSchedulerID;

            $(this).attr("id", tourSchedulerID);

            $(document).on("click", tourSchedulerSelector + " .tour-scheduler-date-selector", function () {
                $(tourSchedulerSelector + " .bookTourButton").data("date", $(this).data("date"));
                $(tourSchedulerSelector + " #tour_schedule_date_picker").val($(this).data("date"));
                $(tourSchedulerSelector + " .tour-scheduler-date-selector").removeClass("date-selected");
                $(this).addClass("date-selected");
            });

            $(document).on("click", tourSchedulerSelector + " #selfGuidedTourButton", function () {
                var utourLink = $(this).data("link");
                utourLink = utourLink + '&desiredDate=' + $(this).data("date");
                $(this).attr("href", utourLink);
            });

            $(tourSchedulerSelector).find("#virtualButton").on('click', virtualButtonClick);
            $(tourSchedulerSelector).find("#inPersonButton").on('click', inPersonButtonClick);

            var slider = tns({
                container: tourSchedulerSelector + " .my-slider",
                items: 3,
                slideBy: 'page',
                autoplay: false,
                loop: false,
                controlsContainer: tourSchedulerSelector + " .tour-schedule-date-slider-controls"
            });

            $(document).on("click", tourSchedulerSelector + " .slider-controls-button", function () {
                var sliderInfo = slider.getInfo();

                if (sliderInfo.displayIndex == 1) {
                    $(tourSchedulerSelector + " .prev").addClass("hide");
                } else {
                    $(tourSchedulerSelector + " .prev").removeClass("hide");
                }

                if (sliderInfo.displayIndex == 12) {
                    $(tourSchedulerSelector + " .next").addClass("hide");
                } else {
                    $(tourSchedulerSelector + " .next").removeClass("hide");
                }
            });

            idCount++;
        });
    }

    
});


$('#tour_schedule_agent_checkbox').on('change', function () {
    if ($('#tour_schedule_agent_checkbox').is(':checked')) {
        $('#company-info').removeClass('hide');
        $('#companyNameInput').attr('required', 'required');
    }
});

$('#tour_schedule_homebuyer_checkbox').on('change', function () {
    if ($('#tour_schedule_homebuyer_checkbox').is(':checked')) {
        $('#company-info').addClass('hide');
        $('#companyNameInput').removeAttr('required');
    }
});

$('#tour-schedule-metro-area-select').on('change', function () {
    var value = $(this).val();
    var communitySelect = $('#tour-schedule-community-select');

    communitySelect.find("option").first().nextAll().remove();

    if (value != '') {
        var id = '';
        if ($('#FormModel_Community').length) {
            id = $('#FormModel_Community').val();
        }

        $.getJSON('/api/Sitecore/MetroCommunity/Community?id=' + value, function (data) {
            appendInputs(data, communitySelect, id);
            
        }).then(function () {
            communitySelect.prop('disabled', false);
            
        });
    } else {
        communitySelect.prop('disabled', true);
    }
});


function appendInputs(data, location, id) {
    $.each(_.sortBy(data.areas), function (i, area) {
        if (!area.id || !area.displayName) return;

        if (area.id == id) {

            location.append('<option value="' + area.id + '" selected="selected">' + area.displayName + '</option>');
        } else {
            location.append('<option value="' + area.id + '">' + area.displayName + '</option>');
        }
    });

}

function InitializeOldTourSchedulerForm() {
    TourScheduleFormProcessSubSource();
    TourScheduleFormProcessLeadSource();
}

function TourScheduleFormProcessSubSource() {
    var inPersonCheckbox = document.getElementById("tour_schedule_inperson_tour_checkbox");
    var virtualCheckbox = document.getElementById("tour_schedule_virtual_tour_checkbox");
    var subSource = document.getElementById("tourScheduleOldSubSource");


    if (inPersonCheckbox == null || virtualCheckbox == null || subSource == null)
        return;

    if (virtualCheckbox.checked)
        subSource.value = _virtual;
    else if (inPersonCheckbox.checked)
        subSource.value = _inperson;
    else
        subSource.value = "";
    console.log(subSource.value);
}

function TourScheduleFormProcessLeadSource() {
    var homebuyerCheckbox = document.getElementById("tour_schedule_homebuyer_checkbox");
    var agentCheckbox = document.getElementById("tour_schedule_agent_checkbox");
    var leadSource = document.getElementById("tourScheduleOldLeadSource");

    if (homebuyerCheckbox == null || agentCheckbox == null || leadSource == null)
        return;

    if (homebuyerCheckbox.checked)
        leadSource.value = _bookATour;
    else if (agentCheckbox.checked)
        leadSource.value = _realtorTour;
    else
        leadSource.value = "";
}